import { useState } from 'react';

function InboundShipments() {
  const [selectedWarehouse, setSelectedWarehouse] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const shipments = [
    {
      id: 'SHP-001',
      reference: 'IB-2024-001',
      origin: 'Shenzhen, China',
      warehouse: 'Dubai 3PL Hub',
      status: 'In Transit',
      eta: '2024-03-25',
      items: [
        { sku: 'WH-001', name: 'Wireless Headphones', quantity: 1000 },
        { sku: 'SW-001', name: 'Smart Watch', quantity: 500 }
      ]
    },
    {
      id: 'SHP-002',
      reference: 'IB-2024-002',
      origin: 'Mumbai, India',
      warehouse: 'Riyadh 3PL Hub',
      status: 'Customs Clearance',
      eta: '2024-03-22',
      items: [
        { sku: 'BT-001', name: 'Bluetooth Speaker', quantity: 800 }
      ]
    },
    {
      id: 'SHP-003',
      reference: 'IB-2024-003',
      origin: 'Istanbul, Turkey',
      warehouse: 'Cairo 3PL Hub',
      status: 'Scheduled',
      eta: '2024-03-28',
      items: [
        { sku: 'PB-001', name: 'Power Bank', quantity: 1200 },
        { sku: 'CC-001', name: 'Phone Cases', quantity: 2000 }
      ]
    }
  ];

  const warehouses = ['all', 'Dubai 3PL Hub', 'Riyadh 3PL Hub', 'Cairo 3PL Hub'];
  const statuses = ['all', 'Scheduled', 'In Transit', 'Customs Clearance', 'Delivered'];

  const getStatusColor = (status) => {
    const colors = {
      'Scheduled': 'bg-blue-100 text-blue-800',
      'In Transit': 'bg-yellow-100 text-yellow-800',
      'Customs Clearance': 'bg-indigo-100 text-indigo-800',
      'Delivered': 'bg-green-100 text-green-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const filteredShipments = shipments.filter(shipment => {
    const matchesWarehouse = selectedWarehouse === 'all' || shipment.warehouse === selectedWarehouse;
    const matchesStatus = selectedStatus === 'all' || shipment.status === selectedStatus;
    return matchesWarehouse && matchesStatus;
  });

  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">Inbound Shipments</h1>

      <div className="bg-white rounded-xl p-6 shadow-sm mb-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Destination Warehouse
            </label>
            <select
              value={selectedWarehouse}
              onChange={(e) => setSelectedWarehouse(e.target.value)}
              className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            >
              {warehouses.map((warehouse) => (
                <option key={warehouse} value={warehouse}>
                  {warehouse === 'all' ? 'All Warehouses' : warehouse}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            >
              {statuses.map((status) => (
                <option key={status} value={status}>
                  {status === 'all' ? 'All Statuses' : status}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold">Active Shipments</h2>
          <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">
            Create New Shipment
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Reference
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Origin
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Warehouse
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  ETA
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredShipments.map((shipment) => (
                <tr key={shipment.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {shipment.reference}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {shipment.origin}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {shipment.warehouse}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(shipment.status)}`}>
                      {shipment.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {shipment.eta}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button className="text-indigo-600 hover:text-indigo-900 mr-4">
                      View Details
                    </button>
                    <button className="text-indigo-600 hover:text-indigo-900">
                      Track Shipment
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default InboundShipments;